<template>
  <div class="box game-summary">
    <!--
    <div>
        <span class="is-size-2 game-summary-heading">
            <a href="https://www.axes2.ca">
                <img class="game-summary-heading-logo" :src="`${$parent.publicPath}img/Axes2-text-logo-sm.png`"/>
            </a>
        </span> 
    </div>
   -->
    <p class="is-size-6 game-summary-datetime">{{ $parent.dateDisplay }}</p>

    <div class="is-size-6">

        <div class="columns">
            <div v-for="player in gameData.players" :player="player" :key="player.player">

                <div v-if="player.name != ''" class="game-summary-player column is-one-half">

                    <p class="is-size-4 game-summary-player-name">
                        <span v-if="gameData.playerDisplayName != null">
                            {{ gameData.playerDisplayName }}
                        </span>
                        <span v-else>
                            {{ player.given_name || player.name }}
                        </span>
                    </p>
<!--
                    <p class="is-size-6">
                        {{ gameData.dateTimeStamp | formatDateTime }}
                    </p>
-->
                    <div v-if="gameData.gameType === 'Solo'">
                        <p v-if="gameData.axe != null && gameData.axe != ''">Axe: {{ gameData.axe }}</p>
                        <span v-if="gameData.country != null && gameData.country != ''">
                            <country-flag v-bind:country='gameData.country' size='big' rounded/>
                        </span>
                    </div>

                    <div v-if="gameData.gameType === 'Tournament'">
                        <div v-for="st in gameData.sets" :key="st.uniqueId">
                            <br/>
                            <span v-if="st.type === 'Finals'" class="is-size-5 is-info is-primary" style="font-weight: bold;">Finals </span>

                            <span class="is-size-5 game-summary-round-title">Set {{st.id}}<br/></span>

                            <!-- TODO handle cases where tournmanet player isn't throwing in this round, don't show round -->
                            <GameSummaryRound ref="gameSummaryRound" 
                                v-bind:player="player" v-bind:rounds="st.rounds" v-bind:gameType="gameData.gameType"/> 
                        </div>
                    </div>
                    <div v-else>
                        <GameSummaryRound ref="gameSummaryRound" 
                            v-bind:player="player" v-bind:rounds="gameData.rounds" v-bind:gameType="gameData.gameType"/> 
                    </div>

                    <br/>
                    <!--<h5 class="is-size-4 has-text-weight-bold is-underlined game-summary-heading-totals">Results</h5>-->
                    <div>
                        <div class="data-holder" style="padding-top: 5px;">
                            <h5 class="is-size-5 game-summary-heading-totals">Rounds</h5>
                            <div class="has-text-weight-light game-summary-game-avg-avg">Avg <span>{{ $parent.$parent.calculateAverageThrow(player,gameData) }}</span></div>
                            <div class="has-text-weight-light game-summary-game-avg-total">Total <span>{{ $parent.$parent.calculateTotalThrows(player,gameData) }}</span></div>
                            <div class="has-text-weight-light game-summary-game-avg-total">Throws <span>{{ $parent.$parent.calculateThrows(player,gameData) }}</span></div>
                        </div>
                        <div v-if="gameData.gameType === 'Tournament'" class="data-holder" style="padding-top: 5px;">
                            <h5 class="is-size-5 game-summary-heading-totals">Finals</h5>
                            <div class="has-text-weight-light game-summary-game-avg-avg">Avg <span>{{ $parent.$parent.calculateAverageThrowFinals(player,gameData) }}</span></div>
                            <div class="has-text-weight-light game-summary-game-avg-total">Total <span>{{ $parent.$parent.calculateTotalThrowsFinals(player,gameData) }}</span></div>
                            <div class="has-text-weight-light game-summary-game-avg-total">Throws <span>{{ calculateThrowsFinals(player,gameData) }}</span></div>
                        </div>
                    </div>

                    <div v-if="gameData.gameType === GameType.ROUNDROBIN">
                        <div class="data-holder">
                            <h5 class="is-size-5 has-text-weight-bold is-underlined game-summary-heading-totals">Finals</h5>
                            <div class="has-text-weight-light game-summary-game-avg-avg">Avg <span>{{ $parent.$parent.calculateAverageThrowFinals(player,gameData) }}</span></div>
                            <div class="has-text-weight-light game-summary-game-avg-total">Total <span>{{ $parent.$parent.calculateTotalThrowsFinals(player,gameData) }}</span></div>
                            <div class="has-text-weight-light game-summary-game-avg-total">Throws <span>{{ $parent.calculateThrowsFinals(player,gameData) }}</span></div>
                        </div>
                    </div>

                    <div style="width: 100%;" class="has-text-left">
                        <br/>
                        <div class="throw-points" v-if="gameData.gameType === 'Solo'">
                            <div v-if="!$parent.isLoading">
                                <vue-bar-graph
                                    :points=$parent.calculateThrowPoints(player)
                                    :show-x-axis="true"
                                    :show-y-axis="false"
                                    :width="260"
                                    :height="130"
                                    :labels="['0','1', '2', '3', '4', '5']"
                                    :show-values="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
    .box {
        background-color: #383838;
    }
    .data-holder {
        height: 100px;
    }
    .game-summary {
        border: solid yellow 1px;
        background-color: black !important;
        font-family: Arial;
        color: yellow;
    }
    .game-summary-player-name,
    .game-summary-round-headings,
    .game-summary-heading-totals {
        color: rgb(59, 142, 250)
    }
    .game-summary-player {
        margin: 2px;
        padding: 2px;
        border: solid gray 1px;
        //display: inline;
        //float: left;
    }
    .game-summary-logo {
        width: 60px;
    }
    .game-summary-user-picture {
        vertical-align: middle;
        width: 40px;
        border-radius: 10px;
    }
    .game-summary-round {
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .game-summary-heading {
        font-family: '28 Days Later';
    }
    .game-summary-heading-logo {
        max-height: 70px !important;
        width: 200px;
        height: 70px;
    }
    .game-summary-heading,
    .game-summary-datetime,
    .game-summary-round-title {
    }
    .game-summary-heading,
    .game-summary-round-title {
        font-weight: bold;
        margin-bottom: 10px;
    }
    .game-summary-datetime {
        padding: 10px;
    }
    /*
    .game-summary-game-avg {
        color: rgb(221, 243, 95);
        font-weight: bold;
        margin-top: 10px;
        height: 100%;
        width: 340px;
    }
    */
    .game-summary-game-avg-avg {
        display: inline;
        width: 100%;
        float: left;
    }
    .game-summary-game-avg-total {
        display: inline;
        width: 100%;
        float: left;
    }
</style>

<script>
import VueBarGraph from 'vue-bar-graph';
import GameSummaryRound from './GameSummaryRound.vue';
import { GameType } from '@/enum/gameType.js';

export default {
  name: "GameSummary",
  data () {
    return {
        GameType
    }
  },
  components: { 
    VueBarGraph,
    GameSummaryRound 
  },
   props: {
     gameData: {}
   }, 
  methods: {
    calculateThrowsFinals(player,gameData) {
        return this.$parent.calculateThrowsFinals(player,gameData);
    }
   },
  mounted(){ }
};
</script>
